import { z } from 'zod';

import { IdSchema, NonEmptyStringSchema } from '../../base';
import {
  LocalizedTextSchema,
  TranslationBaseSchema,
} from './translations.schema';

export const CreateLanguageTranslationSchema = TranslationBaseSchema.describe(
  'Create a new translation group with initial language variants',
);

export type CreateLanguageTranslationPayload = z.infer<
  typeof CreateLanguageTranslationSchema
>;

export const DeleteTranslationSchema = z
  .object({
    id: IdSchema,
  })
  .describe('Delete a translation group by its ID');

export type DeleteTranslationPayload = z.infer<typeof DeleteTranslationSchema>;

const UpdateLocalizedTextSchema = LocalizedTextSchema.partial().extend({
  languageCode: NonEmptyStringSchema,
});

export const UpdateLanguageTranslationSchema = z
  .object({
    id: IdSchema,
    translationKey: NonEmptyStringSchema.optional(),
    translations: z.array(UpdateLocalizedTextSchema),
  })
  .describe(
    "Update a translation group's language variants and optionally translationKey",
  );

export type UpdateLanguageTranslationPayload = z.infer<
  typeof UpdateLanguageTranslationSchema
>;
